import { render, staticRenderFns } from "./tipDia.vue?vue&type=template&id=c9577b2c&scoped=true&"
import script from "./tipDia.vue?vue&type=script&lang=js&"
export * from "./tipDia.vue?vue&type=script&lang=js&"
import style0 from "./tipDia.vue?vue&type=style&index=0&id=c9577b2c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9577b2c",
  null
  
)

export default component.exports